import { render } from "./SharedWithMe.vue?vue&type=template&id=4011b38e"
import script from "./SharedWithMe.vue?vue&type=script&lang=js"
export * from "./SharedWithMe.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__